export enum LearningPathEnrollStatus {
  pending = 0,
  inProgress = 1,
  finished = 2,
}
